<template>
  <div class="ansi-layers-root">
    <div class="card menu-bg-blue-transparent dll-container">
      <!-- Data panel header -->
      <div v-if="isUshrUser && customerName" id="customerNameLabel" class="data-panel">
        <fa
          :icon="['fas', isMinimized ? 'caret-up' : 'caret-down']"
          class="data-panel__minimize cursor"
          :title="isMinimized ? 'Expand layer list' : 'Minimize layer list'"
          @click="toggleMinimize"
        />
        <b-row no-gutters class="mb-2">
          <b-col cols="12">
            <button class="change-region-btn" title="Change Dataset" @click="$bvModal.show('datasetSelection')">
              <svg class="change-region-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="8" cy="8" r="6.5" stroke="currentColor" stroke-width="1.2"/>
                <path d="M8 1.5C8 1.5 10.5 4 10.5 8S8 14.5 8 14.5M8 1.5C8 1.5 5.5 4 5.5 8S8 14.5 8 14.5M1.5 8h13" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
              </svg>
              <span>Change Dataset</span>
            </button>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="layer-list-font">{{ customerName }}</b-col>
        </b-row>
        <b-row v-if="selected">
          <b-col class="layer-list-font">{{ selected.release_date_formatted + ' - ' + selected.extent_description }}</b-col>
        </b-row>
        <b-row v-if="selected">
          <b-col class="layer-list-font">{{ selected.release_label }}</b-col>
        </b-row>
        <b-row v-if="currentANSISelset">
          <b-col class="layer-list-font">{{ currentANSISelset }}</b-col>
        </b-row>

        <div v-if="isUshrUser" class="ansi-side-col">
          <MMP_ANSI_Tools
            ref="ANSI_Tools"
            :ansiLayersButtonCtrl="ansiLayersButtonCtrl"
            :currentANSISelset="currentANSISelset"
            :currentANSIPartNumber="currentANSIPartNumber"
            :layerDefinition="layerDefinition"
            :map="map"
            :mmp_layersObj="mmp_layersObj"
            :otonomoFeatureTableSubcountry="otonomoFeatureTableSubcountry"
            :selectedExtent="selectedExtent"
            :showStreetView="showStreetView"
            :currentAnsiSegment="currentAnsiSegment"
            :user="user"
            :otonomoEditedSubcountry="otonomoEditedSubcountry"
            :otonomoFilters="otonomoFilters"
            @getAnsiSelectedSelset="$emit('getAnsiSelectedSelset', $event)"
            @getGSV="$emit('getGSV', $event)"
            @getLegend="$emit('getLegend', $event)"
            @initANSIFeatureTable="$emit('initANSIFeatureTable', $event)"
            @initBiasedFeatureTable="$emit('initBiasedFeatureTable', $event)"
            @initBIASEDReports="$emit('initBIASEDReports')"
            @initANSIReports="$emit('initANSIReports')"
            @initIntersectionReports="$emit('initIntersectionReports')"
            @initResize="$emit('DLLChange')"
            @otonomoToggledOff="$emit('otonomoToggledOff')"
            @setOtonomoSubcountryNames="$emit('setOtonomoSubcountryNames', $event)"
            @subcountryChanged="$emit('subcountryChanged')"
            @toggleGSV="$emit('toggleGSV', $event)"
            @updateAnsiLayerName="$emit('updateAnsiLayerName', $event)"
            @updateANSISelset="$emit('updateANSISelset', $event)"
          />
        </div>
      </div>

      <div class="card-body-padding" v-show="!isMinimized">
        <!-- Scrollable Layer List -->
        <div class="scroll-Container">
          <MMP_DLL
            ref="ansiDLL"
            :ansiLayersButtonCtrl="ansiLayersButtonCtrl"
            :ansiLayersToggle="ansiLayersToggle"
            :customerProjectId="customerProjectId"
            :filterClassesObj="filterClassesObj"
            :isUshrUser="isUshrUser"
            :isTabNav="false"
            :layerResponse="layerResponse"
            :map="map"
            :mmp_layersObj="mmp_layersObj"
            :otonomoSubcountry="otonomoSubcountry"
            :rules="rules"
            :selectAllControl="selectAllControl"
            :showANSILayers="showLayers"
            :spinnerManager="spinnerManager"
            :zoomEnded="zoomEnded"
            :zoomLevelCap="zoomLevelCap"
            :layerDefinition="layerDefinition"
            :showLidarPanel="showLidarPanel"
            :baseMapsOpen="baseMapsOpen"
            :extentsOpen="extentsOpen"
            @removeLayerListener="$emit('removeLayerListener')"
            @basemapcollapse="$emit('basemapcollapse')"
            @getFilterModal="getFilterModal($event.layer, $event.id)"
            @getLegend="$emit('getLegend', $event)"
            @getShowAttributes="$emit('getShowAttributes', $event)"
            @layerButtonsChanged="$emit('layerButtonsChanged', $event)"
            @loadAttributes="$emit('loadAttributes', $event)"
            @toggleLayers="toggleANSILayers()"
            @toggleLayerVisibility="$emit('toggleLayerVisibility', $event)"
            @toTopOfList="$emit('toTopOfList', $event)"
            @updateZoomEnded="$emit('updateZoomEnded', $event)"
          />
        </div>

        <MMP_LayerFilterModal
          :filter_layer="filter_layer"
          :generateCQLObj="generateCQLObj"
          :layerProperties="layerProperties"
          :map="map"
          :mmp_layersObj="mmp_layersObj"
          :selectedElement="selectedElement"
          :selsetCQL="`selset='${currentANSISelset}'`"
          :user="user"
          :zoomLevelCap="zoomLevelCap"
          @filterClassesObjChanged="filterClassesObj = $event"
          @rulesChanged="rules = $event"
          @saveOtonomoRules="$emit('saveOtonomoRules', $event)"
        />
      </div>
    </div>
  </div>
</template>


<style scoped>
.ansi-layers-root {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 10px;
}

.ansi-side-col {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

/* When nested inside the data-panel header, separate the tools from the
   release info with a divider and give them room to breathe. */
.data-panel .ansi-side-col {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  gap: 10px;
  align-items: center;
}

.dll-container {
  background-color: transparent !important;
  width: 20rem;
  text-shadow: none !important;
}
.card {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 20px);
  /* overflow: hidden; */
  overflow-x: hidden;
  position: relative;
  border: none;
}
.card-body-padding {
  flex: 1;
  min-height: 0;
  /* overflow: hidden; */
  display: flex;
  flex-direction: column;
  /* padding-top: 0.5rem; */
}
.card-body-padding > div {
  flex: 1;
  min-height: 0;
  /* overflow: hidden; */
  display: flex;
  flex-direction: column;
}
.scroll-Container {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

/* ── Data panel header ── */
.data-panel {
  width: 100%;
  background-color: #063c6d;
  color: white;
  padding: 12px 14px;
  position: relative;

}
.data-panel__minimize {
  position: absolute;
  bottom: 35%;
  right: 10px;
  font-size: 22px;
  color: #ffffff;
  cursor: pointer;
  z-index: 2;
}
.data-panel__minimize:hover {
  opacity: 0.7;
}
.layer-list-font {
  font-size: 13px !important;
  font-weight: 500;
}
.change-region-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  background: linear-gradient(135deg, rgba(32, 255, 155, 0.18) 0%, rgba(4, 150, 233, 0.15) 100%);
  border: 1.5px solid rgba(32, 255, 155, 0.6);
  border-radius: 8px;
  color: #20ff9b;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 5px 10px;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  box-shadow: 0 0 10px rgba(32, 255, 155, 0.2), inset 0 1px 0 rgba(255,255,255,0.08);
  transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;
}
.change-region-btn:hover {
  background: linear-gradient(135deg, rgba(32, 255, 155, 0.32) 0%, rgba(4, 150, 233, 0.25) 100%);
  border-color: #20ff9b;
  box-shadow: 0 0 18px rgba(32, 255, 155, 0.45), 0 2px 8px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.1);
  transform: translateY(-1px);
  color: #fff;
  text-shadow: 0 0 8px rgba(32, 255, 155, 0.8);
}
.change-region-btn:active {
  transform: translateY(0);
  box-shadow: 0 0 6px rgba(32, 255, 155, 0.25);
}
.change-region-icon {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}

/* ── Scrollbar ── */
.scroll-Container::-webkit-scrollbar {
  width: 5px;
}
.scroll-Container::-webkit-scrollbar-track {
  background-color: transparent !important;
  box-shadow: none !important;
}
.scroll-Container::-webkit-scrollbar-thumb {
  background-color: transparent !important;
  border-radius: 999px;
}
.card:hover .scroll-Container::-webkit-scrollbar-track {
  background-color: rgba(6, 60, 109, 0.06) !important;
  border-radius: 999px;
}
.card:hover .scroll-Container::-webkit-scrollbar-thumb {
  background-color: rgba(6, 60, 109, 0.25) !important;
}
.card:hover .scroll-Container::-webkit-scrollbar-thumb:hover {
  background-color: rgba(6, 60, 109, 0.5) !important;
}
</style>

<script>
import axios from 'axios'
import MMP_DLL from './../shared/MMP_DLL.vue'
import MMP_LayerFilterModal from './../shared/MMP_LayerFilterModal.vue'
import MMP_ANSI_Tools from './MMP_ANSI_Tools.vue'
export default {
  name: 'MMP_ANSI_Layers',
  components: {
    MMP_DLL,
    MMP_LayerFilterModal,
    MMP_ANSI_Tools
  },
  props: [
    'ansiLayersButtonCtrl',
    'currentANSIPartNumber',
    'currentANSISelset',
    'customerName',
    'customerProjectId',
    'isUshrUser',
    'layersListMaxHeight',
    'layerResponse',
    'mmp_layersObj',
    'map',
    'olSelectkey',
    'otonomoSubcountry',
    'persistingLayerFilters',
    'selectedExtent',
    'spinnerManager',
    'user',
    'zoomEnded',
    'zoomLevelCap',
    'layerDefinition',
    'showLidarPanel',
    'baseMapsOpen',
    'extentsOpen',
    'showStreetView',
    'currentAnsiSegment',
    'otonomoFeatureTableSubcountry',
    'otonomoEditedSubcountry',
    'otonomoFilters'
  ],
  data() {
    return {
      ansiLayersToggle: true,
      app: 'ansi',
      delivery_coverage_store: null,
      extentRecentlyChanged: true,
      filterClassesObj: null,
      filter_layer: null,
      filter_operator: null,
      filter_property: null,
      filter_value: null,
      generateCQLObj: null,
      layerButtons: null,
      layerProperties: [],
      releases: null,
      rules: [],
      selected: null,
      selectedElement: null,
      selectAllControl: false,
      showLayers: false,
      store_name: null,
      workspace: null,
      isMinimized: false
    }
  },
  methods: {
    toggleMinimize() {
      this.isMinimized = !this.isMinimized
    },
    getFilterModal(layer, id) {
      this.selectedElement = id
      this.filter_layer = layer
      /* This function clears all previous selections of rules and calls
      a function for getting filter properties based on layer selection */
      this.getFilterProperties()
      this.$bvModal.show('filterModal')
    },
    getFilterProperties() {
      /* This function gets the current layer name and finds the source and store
      name of the layer. The url generated is completely dynamic and used for all
      customers. Describe feature gets the feature types from the geoserver layer. */
      let mmpLayer = this.mmp_layersObj[this.filter_layer]
      let layerType = mmpLayer.layer.getSource().params_.LAYERS
      let lastItem = layerType.split(':')[0]
      let url = mmpLayer.geoserverName.split('?')[0] + '?'

      // Geoserver Web Feature Service
      if (sessionStorage.token) {
        axios
          .get(url, {
            params: {
              service: 'WFS',
              version: '1.1.0',
              request: 'DescribeFeatureType',
              typename: layerType,
              name: this.filter_layer,
              wsName: lastItem,
              srsname: 'EPSG:4326',
              outputFormat: 'application/json',
              INFO_FORMAT: 'application/json',
              authkey: sessionStorage.token
            }
          })
          .then(response => {
            let tempProps = []
            response.data.featureTypes[0].properties.forEach(item => {
              tempProps.push({name: item.name})
            })
            this.layerProperties = tempProps
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    getReleases(id) {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/release/project_mmp/' + id, {
            method: 'GET',
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (!content.errors) {
              this.releases = content
              this.release_id = content[0].id
              this.store_name = content[0].store_name
              this.workspace = content[0].workspace
              this.delivery_coverage_store = content[0].delivery_coverage_store
              if (this.customerName != 'GM ANSI') {
                this.showLayers = true
                this.$emit('getLayers', {
                  release_id: this.release_id,
                  store_name: this.store_name,
                  workspace: this.workspace,
                  delivery_coverage_store: this.delivery_coverage_store
                })
              }
              // Sorts releases in descending date order
              let descData = this.releases.toSorted((a, b) => new Date(b.release_date) - new Date(a.release_date))
              this.$emit('gotANSIReleases', descData)
            } else {
              console.log('project_mmp/ API Call Error: ' + content.errors)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    updatePartNumber(e) {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/release/release/' + e.id, {
            method: 'GET',
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (!content.errors) {
              if (content[0].project_id != 22) {
                this.release_id = content[0].id
              }
              this.store_name = content[0].store_name
              this.workspace = content[0].workspace
              this.delivery_coverage_store = content[0].delivery_coverage_store
              this.showLayers = true
              this.$emit('clearSpinnerManager')
              this.$emit('clearAnsiSelection')
              this.$emit('getLayers', {
                release_id: this.release_id,
                store_name: this.store_name,
                workspace: this.workspace,
                delivery_coverage_store: this.delivery_coverage_store,
                part_number: e.part_number,
                update_selset: true
              })
            } else {
              console.log('release/ API Call Error: ' + content.errors)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
        this.$emit('onResize')
      } else {
        console.log('No User Token')
      }
    },
    checkLayer(layer) {
      // Checks if layer exists on the map
      let exists = false
      let mapLayersArr = this.map.getLayers().getArray()

      switch (typeof layer) {
        case 'object':
          for (let i in mapLayersArr) {
            // If layer exists, return true
            exists = mapLayersArr[i] == layer
            if (exists) {
              break
            }
          }
          break
        case 'string':
          for (let i in mapLayersArr) {
            // If layer exists, return true
            exists =
              mapLayersArr[i].values_.hasOwnProperty('name') &&
              mapLayersArr[i].values_.name == layer
            if (exists) {
              break
            }
          }
          break
      }

      return exists
    },
    toggleANSILayers() {
      this.ansiLayersToggle = !this.ansiLayersToggle
    },
    getFormattedDate(originalDateString) {
      let originalDateObj = new Date(originalDateString)
      let returnValue = originalDateObj
        .toLocaleString('en-US', {
          dateStyle: 'short'
        })
        .replace(/\//g, '.')
      return returnValue
    }
  },
  mounted() {
    this.getReleases(this.customerProjectId)
    if (this.rules == []) {
      this.rules = this.persistingLayerFilters
    }
    this.layerButtons = this.ansiLayersButtonCtrl
    this.$emit('DLLChange')
  },
  updated() {
    this.$emit('DLLChange')
  },
  watch: {
    ansiLayersButtonCtrl: function (newValue, oldValue) {
      this.layerButtons = newValue
      let layerButtonsLoaded = newValue.length == this.layerResponse.length
      // Checks to see if drtLayersButtonsCtrl has finished being updated
      if (layerButtonsLoaded && !this.extentRecentlyChanged) {
        this.rules = this.persistingLayerFilters
        this.rules.forEach(rule => {
          /* Changing generateCQLObj will trigger a watch in MMP_LayerFilterModal.vue
          to refresh the CQL filter for this rule when the dynamic layer list is reordered */
          this.generateCQLObj = {
            layer: rule.layer,
            enableZoom: false
          }
        })
      } else if (layerButtonsLoaded) {
        // This is necessary for when the dataset is swapped to a new extent
        this.extentRecentlyChanged = false
      }
    },
    currentANSIPartNumber: function (newValue, oldValue) {
      this.selected = newValue
      this.selected.release_date_formatted = this.getFormattedDate(
        this.selected.release_date
      )
      this.updatePartNumber(this.selected)
    },
    rules: function (newValue, oldValue) {
      if (oldValue.length != 0) {
        this.$emit('rulesChanged', newValue)
      }
    },
    selectedExtent: function (newValue, oldValue) {
      this.extentRecentlyChanged = true
    }
  }
}
</script>
